const initialState = {
  data: [],
}

const isPartnersReducer = (state = initialState, action) => {
  switch (action.type) {
      case 'UPDATE_IS_PARTNER': {
          return {
              data: action.payload,
          }
      }

      default:
          return state;
  }
}

export default isPartnersReducer;
